<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditJobTitle" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="名称" prop="PaJobTitle.name">
            <el-input class="input-item" v-model="formData.PaJobTitle.name"
              :clearable="true" placeholder="职称名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaJobTitle.type!=='group'">
          <el-form-item label="级别" prop="PaJobTitle.levelCode">
            <el-select class="input-item" v-model="formData.PaJobTitle.levelCode" :clearable="true" filterable
              placeholder="级别" :loading="EditJobTitle.levelCode.impl.loading"
              @visible-change="EditJobTitle.levelCode.impl.onVisibleChange"
              @change="onLevelCodeValueChange">
              <el-option v-for="item in EditJobTitle.levelCode.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="formData.PaJobTitle.type!=='group'">
          <el-form-item label="津贴" prop="PaJobTitle.allowance">
            <el-input-number class="input-item" v-model="formData.PaJobTitle.allowance"
              :clearable="true"
              placeholder="职称津贴(元)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaJobTitle.detail">
            <el-input class="input-item" v-model="formData.PaJobTitle.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaJobTitle.remark">
            <el-input class="input-item" v-model="formData.PaJobTitle.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="PaJobTitle.sort">
            <el-input-number class="input-item" v-model="formData.PaJobTitle.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditJobTitle:EditJobTitle:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaJobTitleController, DictionaryController } from '@/api';

export default {
  name: 'EditJobTitle',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaJobTitle: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: 1,
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaJobTitle.allowance': [
          {required: true, message: '请输入津贴', trigger: 'blur'},
          {type: 'number', message: '津贴只允许输入数字', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'PaJobTitle.sort': [
          {type: 'integer', message: '排序只允许输入整数', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'PaJobTitle.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      EditJobTitle: {
        formFilter: {
        },
        formFilterCopy: {
        },
        levelCode: {
          impl: new DropdownWidget(this.loadLevelCodeDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 级别下拉数据获取函数
     */
    loadLevelCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_title_level'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 级别选中值改变
     */
    onLevelCodeValueChange (value) {
    },
    /**
     * 更新编辑职称
     */
    refreshEditJobTitle (reloadData = false) {
      this.loadPaJobTitleData().then(res => {
        if (!this.EditJobTitle.isInit) {
          // 初始化下拉数据
        }
        this.EditJobTitle.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditJobTitle.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            levelCodeDictMap: findItemFromList(this.EditJobTitle.levelCode.impl.dropdownList, this.formData.PaJobTitle.levelCode, 'id'),
            ...this.formData.PaJobTitle
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paJobTitleDto: {
            sort: this.formData.PaJobTitle.sort,
            id: this.id,
            pid: this.formData.PaJobTitle.pid,
            type: this.formData.PaJobTitle.type,
            code: this.formData.PaJobTitle.code,
            gcode: this.formData.PaJobTitle.gcode,
            name: this.formData.PaJobTitle.name,
            levelCode: this.formData.PaJobTitle.levelCode,
            detail: this.formData.PaJobTitle.detail,
            allowance: this.formData.PaJobTitle.allowance,
            remark: this.formData.PaJobTitle.remark
          }
        };

        PaJobTitleController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取绩效职称详细信息
     */
    loadPaJobTitleData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaJobTitle.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaJobTitleController.view(this, params).then(res => {
            this.formData.PaJobTitle = {...res.data, isDatasourceInit: true};
            if (this.formData.PaJobTitle.levelCodeDictMap && this.EditJobTitle.levelCode.impl.dirty) {
              this.EditJobTitle.levelCode.impl.dropdownList = [this.formData.PaJobTitle.levelCodeDictMap];
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaJobTitle: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          levelCode: undefined,
          detail: undefined,
          allowance: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sort: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditJobTitle();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaJobTitle = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
